export const REGEX_CONSTANT = Object.freeze({
  email: new RegExp(/^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/),
  password: new RegExp(
    /^(?=^.{6,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/
  ),
  numeric: new RegExp(/^[0-9]+$/),
  mobileNumber: new RegExp(/^[0-9]{7,15}$/),
  alphanumericWithSpace: new RegExp(/^[a-zA-Z0-9\s]+$/),
  startOfLine: /^\n\s/gm,
  imageExtensionPattern: /[^"'<>]+\.(?:png|jpe?g|gif)\b/gi,
  pdfPattern: /[^"'<>]+\.(?:pdf)\b/gi,
  upperCamelCase: /([A-Z])/gm,
  firstForwardSlashMatch: /^.*?\//gm,
  urlToPhoto: /\/([^/?]+)\?/,
  alphaNumeric: /^[a-zA-Z0-9]+$/,
  alphanumericTrimmed: /^[a-zA-Z0-9][a-zA-Z0-9\s_]*[a-zA-Z0-9]$|^[a-zA-Z0-9]$/,
});
